import { render, staticRenderFns } from "./AuditStatisticsIndex.vue?vue&type=template&id=00b703a9&scoped=true&"
import script from "./AuditStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./AuditStatisticsIndex.vue?vue&type=script&lang=js&"
import style0 from "./AuditStatisticsIndex.vue?vue&type=style&index=0&id=00b703a9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b703a9",
  null
  
)

export default component.exports